module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Unique style for every season","subtitle":"Fashion styles","linkLabel":"Shop collection"},"de":{"title":"Einzigartige Stücke für jede Saison","subtitle":"Lassen Sie sich inspirieren","linkLabel":"Shop collection"}}')
  delete Component.options._Ctor
}
